import styles from './Pagination.module.scss'
import { ChevronDoubleLeftIcon } from '@heroicons/react/24/outline'
import { ChevronDoubleRightIcon } from '@heroicons/react/24/outline'

export const Pagination = ({ totalPages, currentPage, onPageChange }) => {
	const pageBlockSize = 5
	const currentBlock = Math.floor((currentPage - 1) / pageBlockSize)
	const startPage = currentBlock * pageBlockSize + 1
	const endPage = Math.min(startPage + pageBlockSize - 1, totalPages)

	// 현재 블록의 페이지 번호들 생성
	const pageNumbers = Array.from({ length: endPage - startPage + 1 }, (_, i) => startPage + i)

	return (
		<div className={styles.pagenation}>
			{/* 이전 블록으로 이동 */}
			{startPage > 1 && (
				<button onClick={() => onPageChange(startPage - 1)} className={styles.arrowButton}>
					<ChevronDoubleLeftIcon
						style={{ width: '14px', height: '14px', color: '#A0A0A0' }}
					/>
				</button>
			)}

			{/* 현재 블록의 페이지 버튼 */}
			{pageNumbers.map((page) => (
				<button
					key={page}
					onClick={() => onPageChange(page)}
					className={`${styles.pageButton} ${currentPage === page ? styles.active : ''}`}>
					{page}
				</button>
			))}

			{/* 다음 블록으로 이동 */}
			{endPage < totalPages && (
				<button onClick={() => onPageChange(endPage + 1)} className={styles.arrowButton}>
					<ChevronDoubleRightIcon
						style={{ width: '14px', height: '14px', color: '#A0A0A0' }}
					/>
				</button>
			)}
		</div>
	)
}
